export function arrayToQueryString(params) {
  return params !== ''
    ? Object.keys(params)
        .map((key) => key + '=' + params[key])
        .join('&')
    : ''
}
